import request from '@/utils/request'
import defaultBuild from '@/api/build'

export function login(data) {
  return defaultBuild({
    // url: '/vue-element-admin/user/login',
    url: '/login',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/vue-element-admin/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/vue-element-admin/user/logout',
    method: 'post'
  })
}
